<div class="col-md-12 mb-30" *ngIf="Selected_Role_Record_Switcher=='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">Role List</h5>
     <br/>
     <br/>

     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Title</label>
        <input [(ngModel)]="Filter_Title" (keyup)="Change_Filter()" name="Filter_Title" type="text" class="form-control"  placeholder="Type here to search...">
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Last Name</label>
        <input [(ngModel)]="Filter_Fullname"  name="Filter_Fullname" type="text" class="form-control"  placeholder="Type here to search...">
      </div>
    </div>

     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="Set_Form_Role_View_Add()"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus"></i> Add New Record</button>
        <button *ngIf="!Procssing" type="button" (click)="ReadData_Role()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

     <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Title</th>
              <th>Registered By</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Role
            |filter:Filter_Title:'title'
            | paginate
                    : {
                        id: 'DataList_Role',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Role
                          |filter:Filter_Title:'title'
                        ).length
                      }
            ">
             <td>{{DataList_Role.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.username}}</td>
              <td>{{item.persianDate}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" class="dropdown-item" (click)="DeleteModal(templateDelete,item)" ><i class="fa  fa-remove"></i>Delete</a>
                          <a style="cursor: pointer;" class="dropdown-item" (click)="Set_Form_Role_View(item,'Form')" ><i class="fa  fa-edit"></i>Edit</a>
                          <a style="cursor: pointer;" class="dropdown-item" (click)="Set_Form_Role_View(item,'Person')" ><i class="fa  fa-user"></i>Personnel</a>
                      </div>
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>

    </div>

    <pagination-controls id="DataList_Role" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>

  </div>
</div>

<div  class="col-md-12 mb-30" *ngIf="Selected_Role_Record_Switcher=='Form'">
  <app-RoleForm [inner_Role]="Selected_Role_Record"
  (outter_Role)="Set_List_Role_View($event)">
  </app-RoleForm>
</div>

<div  class="col-md-12 mb-30" *ngIf="Selected_Role_Record_Switcher=='Person'">
  <app-RoleUser [inner_Role]="Selected_Role_Record"
  (outter_Role)="Set_List_Role_View($event)">
  </app-RoleUser>
</div>

<ng-template #templateDelete>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Role
      '{{Role_Record_Delete.title}}' </h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">

    <button  type="button" class="btn btn-warning"
      (click)="Delete()"> Delete <i class="fa fa-remove"></i></button>

    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>
